import { ChangeEvent, useCallback, useState } from "react";

// MUI
import { Grid, Paper, Typography } from "@mui/material";

// Constants
import actionsList from "@Constants/actionsList";

// Component
import UploadDataButton from "@Layouts/components/Buttons/UploadDataButton";
import { TFTModelHeaderLoader } from "./ITFTModelHeaderLoader";

// Hooks
import { useAuthorization } from "@Common/hooks/Authorization/Authorization";
// Types
import { IPeriodTreeSelection } from "@/Layouts/components/SideBars/PayPeriodSideBar/interfaces";

interface ITFTModelHeaderProps {
	selected: IPeriodTreeSelection;
	isUpdatable?: boolean;
	isLoading?: boolean;
}
export const TFTModelHeader = (props: Readonly<ITFTModelHeaderProps>) => {
	const { selected, isUpdatable = false, isLoading = false } = props;

	//States
	const [ingesting, setIngesting] = useState(false);

	// Permissions
	const { useAuth: isAuthorized } = useAuthorization();
	const canUploadTimeReport = isAuthorized(actionsList.UPLOAD_TECHNICIAN_FLAGGED_TIME_REPORT);

	const handleUploadFile = useCallback((event: ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];

		if (file?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
			setIngesting(true);
		}
	}, []);

	if (isLoading) {
		return <TFTModelHeaderLoader isUpdatable={isUpdatable} />;
	}

	if (!selected) {
		return <Grid item xs={12} />;
	}

	return (
		<Grid item xs={12}>
			<Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
				<Grid item>
					<Typography className="!font-montserrat !font-medium !text-2xl/[1.2] text-default" component="div">
						{selected?.titleExtended} Technician Flagged Time
					</Typography>
				</Grid>
				<Grid item className="!pr-0">
					<Grid container direction="row" justifyContent="space-between" spacing={6}>
						<Grid item>
							<Paper elevation={0}>
								{isUpdatable && (
									<UploadDataButton
										title="Upload Report"
										className={
											"!bg-primary hover:!shadow-big hover:!shadow-primary !rounded-md [&.Mui-disabled]:opacity-50 [&.Mui-disabled]:!text-white !px-[18px] !py-[6px] min-w-[120px]\
											[&_.MuiTypography-root]:!font-sans [&_.MuiTypography-root]:!font-normal [&_.MuiTypography-root]:!text-sm/[normal] z-10"
										}
										accept=".xlsx"
										disabled={!canUploadTimeReport}
										uploading={ingesting}
										onChange={handleUploadFile}
									/>
								)}
							</Paper>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
